import { navigateTo } from 'slate/utils';
import { CommentItem } from './types';

type EditorShadowHost = (HTMLElement & { shadowRoot: ShadowRoot | null }) | null | undefined;

const MAX_FRAMES = 30;

const noop = () => {};

export const resolveCommentCard = (comments: CommentItem[] | undefined, commentId: string) => {
  const target = comments?.find((comment) => comment.id === commentId);
  if (!target) return null;
  if (target.onType !== 'comment') return target;
  return comments?.find((comment) => comment.id === target.onId) ?? target;
};

export const scrollToCommentAnchor = (shadowHost: EditorShadowHost, card: CommentItem) => {
  if (!shadowHost || card.isOrphaned) return noop;

  let cancelled = false;
  let frames = 0;
  const resolve = () => {
    if (cancelled) return;
    if (shadowHost.shadowRoot?.querySelector(`#anchor-${card.onId}`)) {
      navigateTo(shadowHost, `anchor-${card.onId}`);
      return;
    }
    if (frames++ < MAX_FRAMES) requestAnimationFrame(resolve);
  };
  resolve();

  return () => {
    cancelled = true;
  };
};

export const revealCommentCard = (cardId: string) => {
  let cancelled = false;
  let frames = 0;
  const reveal = () => {
    if (cancelled) return;
    const cardNode = document.querySelector(`[data-comment-id="${cardId}"]`);
    if (cardNode) {
      cardNode.scrollIntoView({ block: 'nearest' });
      return;
    }
    if (frames++ < MAX_FRAMES) requestAnimationFrame(reveal);
  };
  requestAnimationFrame(reveal);

  return () => {
    cancelled = true;
  };
};
